import { useQuery } from "@apollo/client";
import type { Agent, AgentsConnection } from "@casey/db-types";
import { GET_ORGANIZATION_AND_SYSTEM_TEMPLATES } from "../gql";

interface OrganizationAndSystemTemplatesVariables {
  organizationId: string;
}

interface OrganizationAndSystemTemplatesResponse {
  agents: AgentsConnection;
}

export function useOrganizationAndSystemTemplates(organizationId: string) {
  const { data, loading, error, refetch } = useQuery<
    OrganizationAndSystemTemplatesResponse,
    OrganizationAndSystemTemplatesVariables
  >(GET_ORGANIZATION_AND_SYSTEM_TEMPLATES, {
    variables: { organizationId },
    skip: !organizationId,
    errorPolicy: "all",
  });

  return {
    templates:
      data?.agents?.nodes?.filter(
        (template): template is Agent => template !== null,
      ) || [],
    loading,
    error,
    refetch,
  };
}

export type { Agent };
